import { useState } from 'react';
import { Formik } from 'formik';
import { Modal, TextArea } from 'components';
import handWithGift from 'assets/img/hand-with-gift.svg';
import { useWindowSize } from 'hooks';
import { initialValues, schema } from './config';

export default function DevolutionFlux({ show, onClose = () => {} }) {
  const [currentStep, setCurrentStep] = useState(1);
  const [, { isMobile }] = useWindowSize();

  const handleClose = () => {
    onClose(currentStep);
    setCurrentStep(1);
  };

  const handleSubmit = () => {};

  const renderStep1 = (
    <Modal
      icon={handWithGift}
      show={show}
      titleClassName="text-center my-3"
      title="¿Quieres devolver tu regalo?"
      actionLabel="Aceptar"
      onAction={() => setCurrentStep(2)}
      onClose={handleClose}
      type="single"
      center={isMobile}
      subtitle={
        <p className="text-center">
          Para devolver el producto acude a tienda física con el o comunicate
          al: <strong className="text-primary">55 5555 5555</strong>
        </p>
      }
    />
  );

  const renderStep2 = (
    <Modal
      show={show}
      title="Motivos de la devolución"
      actionLabel="Enviar"
      onClose={handleClose}
      onSubmit={handleSubmit}
      center={isMobile}
      className="pt-4 pb-1"
    >
      <TextArea name="motive" />
    </Modal>
  );

  const RENDER_STEPS = [renderStep1, renderStep2];

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={schema}
      onSubmit={handleSubmit}
    >
      {RENDER_STEPS[currentStep - 1]}
    </Formik>
  );
}
